// extracted by mini-css-extract-plugin
module.exports = {"candidateResultStatusWrap":"QLkjx","pipe":"jKI0k","statusCap":"YhJlS","leading":"GGVzB","trailing":"xMNgK","won":"l2mfF","lost":"xaRSy"};